// import Report from '@/views/report'
import recordDetail from '@/views/record/record/detail.vue'
import workDetail from '@/views/record/work/detail.vue'
import workUpload from '@/views/record/work/upload.vue'
import liveList from '@/views/record/live/list.vue'
import liveDetail from '@/views/record/live/detail.vue'
export default [
    {
        path: 'recordDetail',
        name: 'recordDetail',
        component: recordDetail,
    },
    {
        path: 'workDetail',
        name: 'workDetail',
        component: workDetail,
    },
    {
        path: 'workUpload',
        name: 'workUpload',
        component: workUpload,
    },
    {
        path: 'liveList',
        name: 'liveList',
        component: liveList,
    },
    {
        path: 'liveDetail/:taskId',
        name: 'liveDetail',
        component: liveDetail,
    },
]
